require('./js/main');
require('./scss/main.scss');
let ctx = require.context('./js/lib', false, /\.ts|js$/);
ctx.keys().forEach((key) => {
	try {
		ctx(key);
	} catch (e) {
		console.error('lib module failed to load:', key, e);
	}
});